import { autorun, set, toJS } from 'mobx';

export function autoSave(
    _this: any,
    name: string,
    cacheList: string[],
    transform: (values: Record<string, any>) => Record<string, any> = (values) => values,
) {
    const storedJson = localStorage.getItem(name);
    if (storedJson) {
        set(_this, Object.assign(_this, JSON.parse(storedJson)));
    }
    autorun(() => {
        const value = toJS(_this);
        const pickedValues = Object.assign({}, ...cacheList.map((key) => ({ [key]: value[key] })));
        localStorage.setItem(name, JSON.stringify(transform(pickedValues)));
    });
}
